<template>
    <font-awesome-icon :icon="icon" :spin="spin" :size="size" />
</template>

<script>
    export default {
        name: 'Icon',
        props: {
            icon: {
                type: [ String, Array ],
                required: true
            },
            spin: Boolean,
            size: String
        }
    }
</script>